var _excluded = ["name", "className", "fieldID", "size", "placeholder", "iconName", "inlineIconName", "iconType", "disabled", "label", "inlineLabel", "description", "error", "required", "optional", "searchable", "isExpanded", "onClick", "onFocus", "onBlur", "onKeyDown", "removeMarginTop"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Input from '../Input';
import Label from '../Label';
import Icon from '../Icon';

var DropdownField = function DropdownField(_ref) {
  var _classnames, _classnames2;

  var name = _ref.name,
      className = _ref.className,
      fieldID = _ref.fieldID,
      size = _ref.size,
      placeholder = _ref.placeholder,
      iconName = _ref.iconName,
      inlineIconName = _ref.inlineIconName,
      iconType = _ref.iconType,
      disabled = _ref.disabled,
      label = _ref.label,
      inlineLabel = _ref.inlineLabel,
      description = _ref.description,
      error = _ref.error,
      required = _ref.required,
      optional = _ref.optional,
      searchable = _ref.searchable,
      isExpanded = _ref.isExpanded,
      onClick = _ref.onClick,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onKeyDown = _ref.onKeyDown,
      removeMarginTop = _ref.removeMarginTop,
      parentProps = _objectWithoutProperties(_ref, _excluded);

  var iconClass = classnames((_classnames = {
    input__icon: true
  }, _defineProperty(_classnames, "input__icon-".concat(size), true), _defineProperty(_classnames, 'cursor-pointer', !disabled), _defineProperty(_classnames, 'input__icon-error', error), _defineProperty(_classnames, 'opacity-50p', disabled), _defineProperty(_classnames, 'cursor-not-allowed', disabled), _classnames));
  var fieldBoxClass = classnames((_classnames2 = {
    input__field: true,
    'input-skin': true,
    'display-flex': true,
    'align-items-center': true,
    'cursor-pointer': !disabled
  }, _defineProperty(_classnames2, "height-".concat(size), true), _defineProperty(_classnames2, "select--".concat(size), true), _defineProperty(_classnames2, 'input-skin--error', error), _defineProperty(_classnames2, 'input-skin--disabled', disabled), _defineProperty(_classnames2, 'cursor-not-allowed', disabled), _defineProperty(_classnames2, 'whitespace-nowrap', true), _classnames2));
  var fieldTextClass = classnames({
    'color-text': !!parentProps.value,
    input__placeholder: !parentProps.value,
    'cursor-pointer': !disabled,
    'cursor-not-allowed': disabled,
    'marginright-lg': true,
    'overflowx-hidden': true
  });
  var descClass = classnames({
    input__info: true,
    'color-text': !!parentProps.value,
    'opacity-50p': disabled,
    'cursor-not-allowed': disabled
  });
  var inlineLabelClass = classnames({
    'input__label--inline': true,
    'display-inlineblock': true,
    'paddingright-md': true,
    'cursor-pointer': !disabled,
    'opacity-100p': disabled,
    'cursor-not-allowed': disabled
  });
  var inputLabelClass = classnames({
    'input__label-required__container': true,
    'input__label--no-margintop': removeMarginTop,
    'opacity-50p': disabled
  });

  var dropdownFieldAdaProps = _objectSpread(_objectSpread(_objectSpread({
    'aria-invalid': !!error,
    'aria-expanded': isExpanded,
    'aria-haspopup': 'listbox',
    'aria-labelledby': "".concat(fieldID, "-Label")
  }, description && {
    'aria-describedby': "".concat(name, "__description")
  }), error && {
    'aria-describedby': "".concat(name, "__error")
  }), !label && placeholder && {
    'aria-label': placeholder
  });

  return /*#__PURE__*/React.createElement(React.Fragment, null, !searchable ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    role: "presentation",
    onClick: onClick,
    onKeyDown: onKeyDown
  }, !inlineLabel && /*#__PURE__*/React.createElement("div", {
    className: inputLabelClass
  }, label && /*#__PURE__*/React.createElement(Label, {
    text: label,
    className: "input__label",
    id: "".concat(fieldID, "-Label"),
    optional: !required && optional
  }), required && /*#__PURE__*/React.createElement("span", {
    className: "input__label-required font-sm"
  }, "Required")), /*#__PURE__*/React.createElement("div", _extends({}, dropdownFieldAdaProps, {
    className: fieldBoxClass,
    role: "button",
    tabIndex: !disabled ? 0 : -1,
    id: fieldID
  }, parentProps), inlineLabel && /*#__PURE__*/React.createElement(Label, {
    className: inlineLabelClass,
    style: size === 'large' ? {
      fontSize: 15
    } : null,
    text: label,
    id: "".concat(fieldID, "-Label")
  }), /*#__PURE__*/React.createElement("span", {
    className: fieldTextClass
  }, inlineIconName ? /*#__PURE__*/React.createElement(Icon, {
    name: inlineIconName,
    className: "marginright-sm",
    type: iconType
  }) : null, parentProps.value || placeholder)), /*#__PURE__*/React.createElement(Icon, {
    className: iconClass,
    name: iconName
  })), error && /*#__PURE__*/React.createElement("div", {
    role: "alert",
    className: "input__info color-text--error"
  }, error), description && !error ? /*#__PURE__*/React.createElement("div", {
    id: "".concat(name, "__description"),
    className: descClass
  }, description) : null) : /*#__PURE__*/React.createElement("div", {
    role: "presentation",
    onKeyDown: onKeyDown
  }, /*#__PURE__*/React.createElement(Input, _extends({
    name: name,
    className: classnames(className),
    label: label,
    inlineLabel: inlineLabel,
    size: size,
    icon: iconName,
    iconClassName: iconClass,
    onIconClick: onClick,
    placeholder: placeholder,
    disabled: disabled,
    autoComplete: false,
    error: error,
    description: description,
    lblRequired: required,
    optional: !required && optional,
    "aria-expanded": isExpanded,
    "aria-autocomplete": "list",
    fieldID: fieldID,
    onFocus: onFocus,
    onBlur: onBlur,
    removeMarginTop: removeMarginTop
  }, parentProps))));
};

DropdownField.propTypes = {
  name: PropTypes.string,
  fieldID: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string,
  iconName: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  label: PropTypes.string,
  inlineLabel: PropTypes.bool,
  error: PropTypes.string,
  description: PropTypes.string,
  required: PropTypes.bool,
  optional: PropTypes.bool,
  searchable: PropTypes.bool,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  inlineIconName: PropTypes.string,
  iconType: PropTypes.string,

  /** Prop to manage dropdown expanded state for aria-expanded */
  isExpanded: PropTypes.bool,

  /** Remove margin top above the input label */
  removeMarginTop: PropTypes.bool
};
DropdownField.defaultProps = {
  iconName: 'arrow_drop_down',
  size: 'small',
  inlineLabel: false,
  searchable: true,
  isExpanded: false,
  inlineIconName: '',
  fieldID: 'dropdrownField'
};
DropdownField.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DropdownField",
  "props": {
    "iconName": {
      "defaultValue": {
        "value": "'arrow_drop_down'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "size": {
      "defaultValue": {
        "value": "'small'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "inlineLabel": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "searchable": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "isExpanded": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Prop to manage dropdown expanded state for aria-expanded"
    },
    "inlineIconName": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "fieldID": {
      "defaultValue": {
        "value": "'dropdrownField'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "placeholder": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "error": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "description": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "required": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "optional": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onKeyDown": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onFocus": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onBlur": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "iconType": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "removeMarginTop": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Remove margin top above the input label"
    }
  }
};
export default DropdownField;